// extracted by mini-css-extract-plugin
export default {"checkoutBanner":"styles_checkoutBanner__B7fQi","customButton":"styles_customButton__y63sm","spacer":"styles_spacer__Qvdev"};